import axios from '../plugins/axios'

// XAN-24 — gestor de tickets internos (estilo Linear).

export const createTicket = (ticket) => axios.post('/ticket', ticket)

// The API parses its query string with `querystring`, which has no notion of bracket syntax: axios'
// default array format (`assigneeIds[]=a`) arrives there as a key literally named "assigneeIds[]"
// and the route rejects it as unknown. Repeated plain keys are what it reads back as an array.
const serializeTicketParams = (params = {}) => Object.entries(params)
  .filter(([, value]) => value !== undefined && value !== null && value !== '')
  .flatMap(([key, value]) => (Array.isArray(value) ? value : [value])
    .map((item) => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`))
  .join('&')

export const getTickets = (params) => axios.get('/ticket', { params, paramsSerializer: serializeTicketParams })

export const getTicket = (id) => axios.get(`/ticket/${id}`)

export const updateTicket = (id, ticket) => axios.put(`/ticket/${id}`, ticket)

export const deleteTicket = (id) => axios.delete(`/ticket/${id}`)

export const addTicketComment = (id, message, mentionedUserIds = []) =>
  axios.post(`/ticket/${id}/comment`, { message, mentionedUserIds })

export const addTicketAttachment = (id, attachment) => axios.post(`/ticket/${id}/attachment`, attachment)

export const deleteTicketAttachment = (id, attachmentId) => axios.delete(`/ticket/${id}/attachment/${attachmentId}`)

// XAN-193 (adjustments) — dashboard counters. `projectId` scopes them to one project and
// `onlyMine` to the caller's own assignments; both are optional.
export const getTicketSummary = (params) => axios.get('/ticket/summary', { params })

// XAN-193 (adjustments) — every ticket the user can reach, not just the first page. The board lists
// the whole project the way Trello or ClickUp do, and filters (not a page cap) are what narrow it.
//
// The endpoint serves at most TICKET_PAGE_SIZE tickets per request, so the first page is read to
// learn the total and the rest are requested a few at a time in parallel. Results are de-duplicated
// by id: the list is ordered newest first, so a ticket created while the pages load pushes the rest
// down by one and the last ticket of a page would otherwise arrive twice.
export const TICKET_PAGE_SIZE = 200
const PARALLEL_PAGES = 4

export const getAllTickets = async (params = {}) => {
  const first = await getTickets({ ...params, skip: 0, take: TICKET_PAGE_SIZE })
  const pageCount = Math.ceil((first.total || 0) / TICKET_PAGE_SIZE)
  const pages = [first.data]

  for (let page = 1; page < pageCount; page += PARALLEL_PAGES) {
    const batch = []
    for (let offset = page; offset < Math.min(page + PARALLEL_PAGES, pageCount); offset++) {
      batch.push(getTickets({ ...params, skip: offset * TICKET_PAGE_SIZE, take: TICKET_PAGE_SIZE }))
    }
    const responses = await Promise.all(batch)
    responses.forEach((response) => pages.push(response.data))
  }

  const seen = new Set()
  return pages.flat().filter((ticket) => {
    if (seen.has(ticket.id)) return false
    seen.add(ticket.id)
    return true
  })
}
